import { useModal } from "@common/components/Modal/Modal";

interface DiscardNewTicketModalProps {
  setModalActive: (active: boolean) => void;
}

export const useUserFeedbackDiscardNewTicketModal = ({ setModalActive }: DiscardNewTicketModalProps) => {
  const {
    Modal: DiscardNewTicketModal,
    setActive: setDiscardNewTicketModalActive,
    modalProps: discardNewTicketModalProps,
    active,
  } = useModal({ size: "narrower" });

  const onDiscardClick = () => {
    setModalActive(false);
    setDiscardNewTicketModalActive(false);
  };

  return {
    active,
    setDiscardNewTicketModalActive,
    DiscardNewTicketModal,
    discardNewTicketModalProps,
    onDiscardClick,
  };
};
